import { render } from "./CheckoutWhiteReviews.vue?vue&type=template&id=67aa6d01&scoped=true"
import script from "./CheckoutWhiteReviews.vue?vue&type=script&lang=js"
export * from "./CheckoutWhiteReviews.vue?vue&type=script&lang=js"

import "./CheckoutWhiteReviews.vue?vue&type=style&index=0&id=67aa6d01&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67aa6d01"]])

export default __exports__